import AccessMasterJWT from '@cnamts/accessmaster-jwt';
import { axios as axiosInstance } from '@/config/plugins/axios';
import { Strategy } from '@cnamts/accessmaster-jwt/types';

export const TOKEN_COOKIE_NAME = 'accessmasterTokenCookie';

const AccessMaster = new AccessMasterJWT({
	envURI: window.ACCESSMASTER_URI,
	system: window.ACCESSMASTER_OAUTH2_APPLICATION_SYSTEM,
	redirectUri: window.ACCESSMASTER_REDIRECT_URL,
	services: [
		'A51_NAT_ADM',
		'A51_NAT_VAL',
		'A51_NAT_DGOS',
		'A51_CPAM_LIQ',
		'A51_CPAM_MNG_LIQ',
		'A51_CPAM_SUPERVISOR',
		'A51_EVAL_TC',
		'A51_EVAL_DM',
		'A51_NAT_EXPATIENT'
	],
	axiosInstance,
	tokenCookieName: TOKEN_COOKIE_NAME,
	mock: {
		enabled: 'true' === window.ACCESSMASTER_MOCK,
		strategy: 'useMockedServer' as Strategy,
		selectedMockedUser: 'david',
		mockedUser: {
			gender: 'M',
			family_name: 'VIRGIL',
			given_name: 'GRISSOM',
			name: 'VIRGIL GRISSOM',
			num_agent: '18011',
			sub: 'GRISSOM-18011',
			services: [
				{
					nom: 'A51_NAT_ADM',
					paramsFormulaire: '751'
				},
				{
					nom: 'A51_NAT_VAL',
					paramsFormulaire: '751'
				},
				{
					nom: 'A51_NAT_DGOS',
					paramsFormulaire: '751'
				},
				{
					nom: 'A51_CPAM_LIQ',
					paramsFormulaire: '751'
				},
				{
					nom: 'A51_CPAM_MNG_LIQ',
					paramsFormulaire: '751'
				},
				{
					nom: 'A51_CPAM_SUPERVISOR',
					paramsFormulaire: '751'
				},
				{
					nom: 'A51_EVAL_TC',
					paramsFormulaire: '751'
				},
				{
					nom: 'A51_EVAL_DM',
					paramsFormulaire: '751'
				},
				{
					nom: 'A51_NAT_EXPATIENT',
					paramsFormulaire: '751'
				}
			],
			system: window.ACCESSMASTER_OAUTH2_APPLICATION_SYSTEM,
			code_organisme: '751'
		},
		standaloneSelectedMockedUser: 'stagiaire',
		standaloneMockedUsers: {}
	}
});

export default AccessMaster;
